import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthUserService } from '../../Shared/services/auth-user.service';

@Injectable({
  providedIn: 'root'
})
export class IsUserAdminGuard implements CanActivate {

  constructor(public auth: AuthUserService, public router: Router) {}

  canActivate(): boolean {
    if (this.auth.isCurrentUserAdmin) {
      return true;
    } else {
      this.router.navigate(['dashboard']);
      return false;
    }
  }
  
}
